import React, { createContext, FC, useContext, useState } from 'react';

import { TaxForecastPeriod } from '../useTaxForecastData';

const SelectedTaxForecastContext = createContext<
  | [TaxForecastPeriod | undefined, (value: TaxForecastPeriod) => void]
  | undefined
>(undefined);

interface SelectedTaxForecastIdProviderProps {
  children: React.ReactNode;
}

export const SelectedTaxForecastProvider: FC<
  SelectedTaxForecastIdProviderProps
> = ({ children }) => {
  const [selectedTaxForecast, setSelectedTaxForecast] = useState<
    TaxForecastPeriod | undefined
  >();

  return (
    <SelectedTaxForecastContext.Provider
      value={[selectedTaxForecast, setSelectedTaxForecast]}
    >
      {children}
    </SelectedTaxForecastContext.Provider>
  );
};

export const useSelectedTaxForecast = () => {
  const context = useContext(SelectedTaxForecastContext);
  if (context === undefined) {
    throw new Error(
      'useSelectedTaxForecast must be used within a SelectedTaxForecasProvider',
    );
  }
  return context;
};
